import React, { useCallback } from "react";
import { Button, ButtonSize } from "@bale/ui";
import { strings } from "intl/fa";
import styles from "./AdEmptyState.module.scss";
import {
  NavigationActions,
  AppPage,
  SidebarOption,
} from "core/navigation/navigation.slice";
import { useAppDispatch } from "utils/store";

interface propTypes {
  isButtonDisabled: boolean;
}

const AdEmptyState: React.FC<React.PropsWithChildren<propTypes>> = (props) => {
  const dispatch = useAppDispatch();

  const openSubmitAdPage = useCallback(() => {
    dispatch(NavigationActions.setAppPage(AppPage.SubmitAd));
  }, []);

  const openTutorial = useCallback(() => {
    dispatch(NavigationActions.setAppPage(AppPage.Tutorial));
  }, []);

  return (
    <div className={styles.Container}>
      <img src="/images/tricycle.webp" alt="" />
      <div className={styles.TextWrapper}>
        <p className={styles.Welcome}>{strings.ad_sale.welcome}</p>
        <p className={styles.Text}>{strings.ad_sale.first_order_message}</p>
      </div>
      <div className={styles.ButtonWrapper}>
        <Button
          text={strings.ad_sale.add}
          size={ButtonSize.Medium}
          onClick={openSubmitAdPage}
          disable={props.isButtonDisabled}
        />
        <div className={styles.TextButton} onClick={openTutorial}>
          {strings.tutorials.check_tutorial}
        </div>
      </div>
    </div>
  );
};

export default AdEmptyState;
